<script lang="ts">
    import type { SaleTags } from '@shared/types/types';

    interface Props {
        saleTags?: SaleTags;
        rule?: string;
        variationId: string;
    }

    let { saleTags, rule, variationId }: Props = $props();

    const benefitUrl = $derived(
        saleTags?.benefit?.id &&
            rule &&
            `/benefit-sheet/sheet/list/${saleTags.benefit.id}?contextDreson=${rule}&variationId=${variationId}&useOcSheet=true`,
    );
</script>

{#if saleTags?.benefit?.value && benefitUrl}
    <oc-tag-v1
        variant="sale"
        size={'50'}
        data-secondary-action
        show-info-icon
        data-oc-sheet-v1-create
        data-oc-sheet-v1-create.base64-url={btoa(benefitUrl)}>{saleTags.benefit.value}</oc-tag-v1
    >
{/if}
